import axiosInstance from './AxiosInstance';

export function getUsers() {
    return axiosInstance.get(`users`);
}

export function createUser(userData) {
    return axiosInstance.post(`/register`, userData);
}

export function updateUser(userData) {
    return axiosInstance.put(`/users/update`, userData);
}

export function updateProfile(userData) {
    return axiosInstance.put(`/users/${userData.id}/update-personal-info`, userData);
}


export function deleteUsers(userId) {
    return axiosInstance.delete(`/users/${userId}`);
}
